export default __webpack_public_path__ + "static/media/icon_grey_check.fcffa753.svg";